import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/styles';
import { SxProps } from '@mui/system';

import { themeColors } from '~/theme';

export const useSxStyles = (): { chipList: SxProps<Theme> } => {
  const theme = useTheme();

  return {
    chipList: {
      display: 'flex',
      flexWrap: 'wrap',
      listStyle: 'none',
      margin: 0,
      borderRadius: theme.spacing(2.5),
      minHeight: '42px',
      border: 'solid 1px transparent',
      '&.error': {
        borderColor: theme.palette.error.main,
      },
      '& .MuiChip-root': {
        margin: theme.spacing(0.5),
      },
      '&.highlighted': {
        backgroundColor: themeColors.background.grey,
      },
      '&.outlined': {
        borderColor: theme.palette.divider,
        '&.error': {
          borderColor: theme.palette.error.main,
        },
      },
    },
  };
};
